"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnsResizable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var get_passive_event_support_1 = require("../../../_util/get-passive-event-support");
var get_element_offset_1 = require("../../../_util/get-element-offset");
var ResizableTable_1 = require("./ResizableTable");
var TableContext_1 = require("../../TableContext");
function columnsResizable(_a) {
    var minWidth = _a.minWidth, maxWidth = _a.maxWidth, onResizeEnd = _a.onResizeEnd;
    return {
        getInfo: function () { return ({ name: "columnsResizable" }); },
        onInjectProps: function (props) {
            return tslib_1.__assign(tslib_1.__assign({}, props), { columnsResizable: true });
        },
        onInjectTable: function (render) { return function (props) {
            var table = render(props);
            var columns = props.columns;
            return react_1.default.createElement(ResizableTable_1.ResizableTable, { table: table, columns: columns });
        }; },
        onInjectHead: function (render) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var head = render.apply(void 0, tslib_1.__spread(args));
            return react_1.default.createElement(ResizableTable_1.ResizableTableHead, { head: head });
        }; },
        onInjectColumn: function (render) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var result = render(record, rowKey, recordIndex, column, columnIndex);
            if (recordIndex === -1) {
                result.props = Object.assign({}, result.props, {
                    column: column.key,
                });
            }
            // 仅表头注入拖拽元素
            if (recordIndex !== -1 || "ignore" in column) {
                return { props: result.props, children: result.children };
            }
            var children = (react_1.default.createElement(ResizableTableCell, { columnIndex: columnIndex, minWidth: minWidth, maxWidth: maxWidth, onResizeEnd: onResizeEnd, childrenCell: result.children }));
            return { props: result.props, children: children };
        }; },
        onInjectRow: function (renderRow) { return function (record, rowKey, recordIndex, columns) {
            var result = renderRow(record, rowKey, recordIndex, columns);
            result.row = (react_1.default.createElement(ResizableRowCell, { childrenRowCell: result.row, key: rowKey }));
            return result;
        }; },
    };
}
exports.columnsResizable = columnsResizable;
function ResizableRowCell(_a) {
    var childrenRowCell = _a.childrenRowCell, props = tslib_1.__rest(_a, ["childrenRowCell"]);
    var isResizing = react_1.useContext(ResizableTable_1.ResizeContext).isResizing;
    var className = classnames_1.default(childrenRowCell.props.className, {
        "no-hover": !!isResizing,
    }, props.className);
    return react_1.default.cloneElement(childrenRowCell, tslib_1.__assign(tslib_1.__assign({}, props), { className: className }));
}
function ResizableTableCell(_a) {
    var minWidth = _a.minWidth, maxWidth = _a.maxWidth, onResizeEnd = _a.onResizeEnd, childrenCell = _a.childrenCell, columnIndex = _a.columnIndex, props = tslib_1.__rest(_a, ["minWidth", "maxWidth", "onResizeEnd", "childrenCell", "columnIndex"]);
    var _b = react_1.useContext(ResizableTable_1.ResizeContext), wrapperRef = _b.wrapperRef, lineRef = _b.lineRef, columns = _b.columns, classPrefix = _b.classPrefix, headRef = _b.headRef, setIsResizing = _b.setIsResizing;
    var columnsWidths = react_1.useContext(TableContext_1.TableContext).columnsWidths;
    var startX = 0;
    var fitColumnWidths = function (columns) {
        var tableWidth = headRef.current.clientWidth;
        var totalWidth = 0;
        columns.forEach(function (column) {
            if (column.width) {
                totalWidth +=
                    typeof column.width === "string"
                        ? parseInt(column.width, 10)
                        : column.width;
            }
        });
        if (totalWidth < tableWidth) {
            var lastIndex = columns.length - 1;
            if (typeof columns[lastIndex].width === "undefined") {
                return tslib_1.__spread(columns);
            }
            if (typeof columns[lastIndex].width === "string") {
                columns[lastIndex].width =
                    parseInt(columns[lastIndex].width, 10) +
                        (tableWidth - totalWidth);
            }
            else {
                columns[lastIndex].width =
                    columns[lastIndex].width + (tableWidth - totalWidth);
            }
        }
        return tslib_1.__spread(columns);
    };
    var onResizeStart = function (event) {
        setIsResizing(true);
        var isTouchEvent = false;
        var filterColumns = columns.filter(function (item) { return item.width; });
        var hasReset = filterColumns.length === columnsWidths.length;
        var trNodes = Array.prototype.slice.call(headRef.current.getElementsByTagName("tr"), 0);
        var tdNodes = trNodes && trNodes.length > 0
            ? Array.prototype.slice.call(trNodes[0].childNodes, 0)
            : [];
        if (tdNodes && tdNodes.length === columns.length && !hasReset) {
            tdNodes.forEach(function (tdNode, index) {
                columns[index].width = tdNode.clientWidth;
            });
            var newColumns = columns.filter(function (column) { return !("ignore" in column); });
            onResizeEnd(newColumns);
        }
        if (event.type === "touchstart") {
            if (event.touches && event.touches.length > 1) {
                return;
            }
            isTouchEvent = true;
        }
        startX = isTouchEvent
            ? Math.round(event.touches[0].clientX)
            : event.clientX;
        var left = startX - get_element_offset_1.getElementOffset(wrapperRef.current).left;
        requestAnimationFrame(function () {
            lineRef.current.style.transform = "translate3d(" + left + "px, 0px, 0px)";
            lineRef.current.style.display = "block";
        });
        var eventTarget = event.currentTarget;
        var thNode = eventTarget.parentNode && eventTarget.parentNode.parentNode;
        var moveHandler = function (clientX) {
            var resizeWidth = clientX - startX + thNode.clientWidth;
            var left = clientX - get_element_offset_1.getElementOffset(wrapperRef.current).left;
            var baseLeftPosition = get_element_offset_1.getElementOffset(thNode).left -
                get_element_offset_1.getElementOffset(wrapperRef.current).left;
            if (resizeWidth <= 0) {
                left = baseLeftPosition + minWidth;
            }
            else if (maxWidth && resizeWidth > maxWidth) {
                left = baseLeftPosition + maxWidth;
            }
            else if (minWidth && resizeWidth < minWidth) {
                left = baseLeftPosition + minWidth;
            }
            requestAnimationFrame(function () {
                lineRef.current.style.transform = "translate3d(" + left + "px, 0px, 0px)";
            });
        };
        var handlersAndEvents = {
            mouse: {
                moveEvent: "mousemove",
                moveHandler: function (event) {
                    if (event.cancelable) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    moveHandler(event.clientX);
                    return false;
                },
                upEvent: "mouseup",
                upHandler: function (event) {
                    document.removeEventListener("mousemove", handlersAndEvents.mouse.moveHandler);
                    document.removeEventListener("mouseup", handlersAndEvents.mouse.upHandler);
                    if (lineRef.current && lineRef.current.style) {
                        lineRef.current.style.display = "none";
                    }
                    var resizeWidth = event.clientX - startX + thNode.clientWidth;
                    if (resizeWidth <= 0) {
                        resizeWidth = minWidth;
                    }
                    if (maxWidth && resizeWidth > maxWidth) {
                        resizeWidth = maxWidth;
                    }
                    if (minWidth && resizeWidth < minWidth) {
                        resizeWidth = minWidth;
                    }
                    columns[columnIndex] = Object.assign({}, columns[columnIndex], {
                        width: resizeWidth,
                    });
                    var newColumns = fitColumnWidths(columns);
                    setIsResizing(false);
                    onResizeEnd(newColumns.filter(function (column) { return !("ignore" in column); }));
                },
            },
            touch: {
                moveEvent: "touchmove",
                moveHandler: function (event) {
                    if (event.cancelable) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    moveHandler(event.touches[0].clientX);
                    return false;
                },
                upEvent: "touchend",
                upHandler: function (event) {
                    document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
                    document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
                    if (lineRef.current && lineRef.current.style) {
                        lineRef.current.style.display = "none";
                    }
                    var resizeWidth = event.clientX - startX + thNode.clientWidth;
                    if (resizeWidth <= 0) {
                        resizeWidth = minWidth;
                    }
                    if (maxWidth && resizeWidth > maxWidth) {
                        resizeWidth = maxWidth;
                    }
                    if (minWidth && resizeWidth < minWidth) {
                        resizeWidth = minWidth;
                    }
                    columns[columnIndex] = Object.assign({}, columns[columnIndex], {
                        width: resizeWidth,
                    });
                    var newColumns = fitColumnWidths(columns);
                    setIsResizing(false);
                    onResizeEnd(newColumns.filter(function (column) { return !("ignore" in column); }));
                },
            },
        };
        var events = isTouchEvent
            ? handlersAndEvents.touch
            : handlersAndEvents.mouse;
        var passiveIfSupported = get_passive_event_support_1.passiveEventSupported()
            ? { passive: false }
            : false;
        document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
        document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        childrenCell,
        react_1.default.createElement("span", { draggable: false, className: classPrefix + "-table__resize-line", onMouseDown: onResizeStart, onTouchStart: onResizeStart })));
}
//# sourceMappingURL=resizable.js.map